import editIcon from "../img/edit.png";
import deleteIcon from "../img/delete.png";
import {useContext, useEffect, useState} from "react";
import {APIContext} from "./Globals.tsx";
import TextInputWeex from "./elements/TextInputWeex";
import Select2DateWeex from "./elements/Select2DateWeex";
import {Modal} from "./Modal.tsx";

function filterActive(news){
    let now = Date.now();
    return new Date(news.startDate) <= now && new Date(news.endDate) >= now;
}

function filterUpcoming(news){
    let now = Date.now();
    return new Date(news.startDate) > now;
}

function filterPast(news){
    let now = Date.now();
    return new Date(news.endDate) < now;
}

export function renderNews(news, setAddNew, setData, deleteNews, props){
    return <div className={"card grid newsCard"} {...props}>
        <h4>{news.title}</h4>
        <p>{news.body}</p>
        <div className={"grid gridfour_icons"}>
            <div>
                <label>Ab </label>
                <label>{new Date(news.startDate).toLocaleDateString('de-DE')}</label>
            </div>
            <div>
                <label>Bis </label>
                <label>{new Date(news.endDate).toLocaleDateString('de-DE')}</label>
            </div>
            {setData && <div onClick={() => {
                setData(news);
                setAddNew(true);
            }} style={{cursor: "pointer"}}>
                <img className={"icon"} src={editIcon} alt={"edit"}/>
            </div>}
            {deleteNews && <div onClick={() => {
                deleteNews(news.id).then((e) => e&&window.location.reload());
            }}>
                <img className={"icon"} src={deleteIcon} alt={"delete"}/>
            </div>}
        </div>
    </div>;
}

export default function News(){
    const [news, setNews] = useState([]);
    const [data, setData] = useState({});
    const [addNew, setAddNew] = useState(false);
    const {fetchNews, pushNews, deleteNews} = useContext(APIContext);

    useEffect(() => {
        // Fetch news data from API
        fetchNews().then((res) => {
            console.log(res?.news ?? []);
            setNews(res?.news ?? []);
        });
    }, []);

    useEffect(() => {
        if(!addNew){
            setData({});
        }
    }, [addNew]);

    function renderNewsInput(){
        return <Modal
            actionP={() => pushNews(data).then(() => window.location.reload())}
            actionS={() => setAddNew(false)}
            buttonS={"Schließen"}
            buttonP={"Speichern"}
            valid={data?.title && data?.body && data?.startDate && data?.endDate}
        >
            <TextInputWeex placeholder={"Titel"} value={data.title ?? ""} onChange={(e) => {
                setData({...data, title: e.target.value});
            }}/>
            <br/>
            <TextInputWeex placeholder={"Nachricht..."} rows={10} value={data.body ?? ""} onChange={(e) => {
                setData({...data, body: e.target.value});
            }}/>
            <br/>
            <div className={"flex-row"}>
                <div>
                    <Select2DateWeex value={new Date(data?.startDate)??null} label={"Ab"} onChange={(e) => {
                        setData({...data, startDate: e});
                    }}/>
                </div>
                <div>
                    <Select2DateWeex value={new Date(data?.endDate)??null} label={"Bis"} onChange={(e) => {
                        setData({...data, endDate: e});
                    }}/>
                </div>
            </div>
        </Modal>;
    }

    return (
        <div style={{position: "relative", width: "100%", height: "100%"}}>
            {addNew && <div style={{position: "absolute", width: "100%", height: "100%", zIndex: "100"}}>
                <div style={{
                    width: "50%",
                    margin: "auto"
                }}>
                    {renderNewsInput()}
                </div>
            </div>}
            <button className={"primarybutton"} onClick={() => setAddNew(true)}>Neue Mitteilung</button>
            <h3>Aktiv</h3>
            <div id={"news_activ"} className={"news-container"}>
                {news.filter(filterActive).map((news) =>
                    renderNews(news, setAddNew, setData, deleteNews)
                )}
            </div>
            <h3 className={"news"}>Geplant</h3>
            <div id={"news_planned"} className={"news-container"}>
                {news.filter(filterUpcoming).map((news) =>
                    renderNews(news, setAddNew, setData, deleteNews)
                )}
            </div>
            <h3 className={"news"}>Vergangene</h3>
            <div id={"news_past"} className={"news-container"}>
                {news.filter(filterPast).map((news) =>
                    renderNews(news, setAddNew, setData, deleteNews)
                )}
            </div>

        </div>
    );
}
